module.exports = __webpack_public_path__ + "static/mobile-bbq-95905a55beda101ebe6387858668db04.png";